import Axios from "../services/axios.service";

export const listTreasuryAccountBasedOnTypes = async (payload) => {
  return Axios({
    method: "POST",
    url: `web-services/api/v6/services/admin/account/view-treasury-balance`,
    data: payload,
  });
};
